import styled from 'styled-components';
import { Icon, IconProps } from '../icon/Icon';

interface IconButtonProps {
  icon: IconProps;
  onClickEvent: () => void;
}

export const IconButton = ({ onClickEvent, icon }: IconButtonProps) => {
  return (
    <IconActionButton onClick={onClickEvent}>
      <Icon name={icon.name} width={icon.width} height={icon.height} style={icon.style} />
    </IconActionButton>
  );
};

const IconActionButton = styled.button`
  cursor: pointer;
`;
